import moment from 'moment';

export default function setToMinHours(date: moment.Moment) {
  return date.set('hours', 0).set('minutes', 0).set('seconds', 0);
}
